import {MatSnackBar} from "@angular/material/snack-bar";
import {TranslateService} from "@ngx-translate/core";
import {inject, Injectable} from "@angular/core";

@Injectable({
    providedIn: 'root'
})
export class MotorMessageService {
    private readonly translate: TranslateService = inject(TranslateService);
    private readonly _snackBar: MatSnackBar = inject(MatSnackBar);

    public openSnackBar(messageKey: string, additionalInformation?: string, action?: string) {
        this.translate.get(messageKey).subscribe((label: string) => {
            this._snackBar.open(label + (additionalInformation ?? ''), action, {
                duration: 5000,
                verticalPosition: 'top',
                horizontalPosition: 'right',
            });
        });
    }
}
